//
//
//
//
//
//


export default {
  name: 'Card',
}



// WEBPACK FOOTER //
// ./client/components/Common/Card/Card.vue